// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormatDate as formatDate } from 'shared_components/common/date/Format';

type Props = {
  date?: string,
  countryCode: string,
  type?: 'long' | 'short',
};

/**
 * ShipsFrom
 *
 * @param {Props} props
 */
export const ShipsFrom = ({ date = null, countryCode, type = 'short' }: Props) => {
  if (!countryCode) {
    return null;
  }

  if (date) {
    return (
      <FormattedMessage id={`countries.${countryCode}`}>
        {(countryName: string) => (
          <FormattedMessage
            id={`components.art.${type === 'short' ? 'shipsFromShort' : 'shipsFromLong'}`}
            values={{
              country: countryName,
              date: formatDate({
                value: new Date(date),
                year: 'numeric',
                month: 'long',
                day: '2-digit',
                weekday: 'long',
              }),
            }}
          >
            {(shipsFromText: string) => shipsFromText}
          </FormattedMessage>
        )}
      </FormattedMessage>
    );
  }

  return (
    <FormattedMessage id={`countries.${countryCode}`}>
      {(countryName: string) => (
        <FormattedMessage id="components.art.shipsFromCountry" values={{ country: countryName }}>
          {(shipsFromText: string) => shipsFromText}
        </FormattedMessage>
      )}
    </FormattedMessage>
  );
};
